import styles from "./Header.module.scss";
import HeaderLogo from "../../Assets/images/rapid-header-logo.png";
import { Link } from "react-router-dom";

function Header() {
  return (
    <Link className={styles.mainContainer} to={"/"}>
      <img src={HeaderLogo} alt="logo" className={styles.logo} />
    </Link>
  );
}

export default Header;
